import React, { ReactElement } from "react";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { ReadHomebrew } from "../components/read_homebrew/ReadHomebrew";

export default function Docs(): ReactElement {
  return <ReadHomebrew getKey={() => "resources/FullCharacterSheet.pdf"} />;
}
